import { createQueryParams } from '../../utils/Function/commonFunction';
import axiosBasicInstance from './../axiosConfig';

// const getUserList = async (page, record) => {
//    try {
//       const response = await axiosBasicInstance.get(
//          `management/user?${createQueryParams({
//             page,
//             record,
//          })}`
//       );
//       return response;
//    } catch (error) {

//       throw error;
//    }
// };
const getUserList = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/list-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getLeaveByUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/leavetype-by-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getLeaveByUserByLeaveId = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/leavetype-by-user-by-leavetype', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getUserListAll = async () => {
   try {
      const response = await axiosBasicInstance.get(
         `management/user?${createQueryParams({
            page: 1,
            record: 500,
         })}`
      );

      return response;
   } catch (error) {
      throw error;
   }
};


const getMultipleUserRemoved = async () => {
   try {
      const response = await axiosBasicInstance.get(
         `management/user?${createQueryParams({
            page: 1,
            record: 500,
         })}`,
         {
            headers: {
               inactive: true,
            },
         }
      );
      return response;
   } catch (error) {
      throw error;
   }
};

const addUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const editUser = async (data) => {
   try {
      const response = await axiosBasicInstance.put('/management/user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const deleteUser = async (userId, langId, data) => {
   try {
      const response = await axiosBasicInstance.delete(`/management/user/${userId}/${langId}`, {
         data,
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const removeUser = async (userId, langId, data) => {
   try {
      const response = await axiosBasicInstance.post(`/management/user/remove/${userId}/${langId}`, data);
      return response;
   } catch (error) {
      throw error;
   }
};

const restoreUser = async (userId) => {
   try {
      const response = await axiosBasicInstance.post(`/management/user/restore/${userId}`);
      return response;
   } catch (error) {
      throw error;
   }
};

const blockUser = async (userId, dateEnd, langId) => {
   try {
      // const response = await axiosBasicInstance.post(`/management/user/block/${userId}`);
      const response = await axiosBasicInstance.post(`/management/user/block/${userId}`, null, {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const unblockUser = async (userId, dateEnd, langId) => {
   try {
      // const response = await axiosBasicInstance.post(`/management/user/unblock/${userId}`);
      const response = await axiosBasicInstance.post(`/management/user/unblock/${userId}`, null, {
         headers: {
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const terminateUser = async (userId, dateEnd, langId) => {
   try {
      const response = await axiosBasicInstance.post(`/management/user/terminate/${userId}`, null, {
         headers: {
            dateEnd,
            langId
         },
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const getUserOfRoster = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/userOfRoster', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const addNewUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/addUser', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const updateUser = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/editUser', data);
      return response;
   } catch (error) {
      throw error;
   }
}

const getInfoByCitizen = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/get-info-form-citizen', data);
      return response;
   } catch (error) {
      throw error;
   }
}

const exportUserCSV = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/exportUserManagement', data, {
         responseType: 'blob'  
      });
      return response;
   } catch (error) {
      throw error;
   }
};

const editEntitlement = async (data) => {
   try {
      const { userId, leaveTypeId, ...body } = data;

      const response = await axiosBasicInstance.post(
         `/management/user/${userId}/leave-types/${leaveTypeId}`,
         body,
         { withCredentials: true }
      );

      return response;
   } catch (error) {
      throw error;
   }
};

const getGroupByUserList = async (data) => {
   try {
      const response = await axiosBasicInstance.post('/management/user/list-group-by-user', data);
      return response;
   } catch (error) {
      throw error;
   }
};

const getDeviceByUser = async (data) => {
   const response = await axiosBasicInstance.post(
      '/management/user/device-user',
      data,
      {
         headers: {
            'Content-Type': 'application/json',
         },
      }
   );
   return response;
};

const getDetailByUser = async (data) => {
   const response = await axiosBasicInstance.post(
      '/management/user/detail-user',
      data,
      {
         headers: {
            'Content-Type': 'application/json',
         },
      }
   );
   return response;
};

const deleteDevice = async (data) => {
   const response = await axiosBasicInstance.post(
      '/management/user/delete-devices',
      data,
   );
   return response;
};


export {
   addUser,
   blockUser,
   deleteUser,
   editUser,
   getMultipleUserRemoved,
   getUserList,
   getUserListAll,
   removeUser,
   restoreUser,
   terminateUser,
   unblockUser,
   getUserOfRoster,
   addNewUser,
   updateUser,
   getInfoByCitizen,
   exportUserCSV,
   getLeaveByUser,
   getLeaveByUserByLeaveId,
   editEntitlement,
   getGroupByUserList,
   getDeviceByUser,
   getDetailByUser,
   deleteDevice
};
